import React,{useState} from "react";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { PageHeader } from "./PageHeader"
import {DataBox} from "./DataBox"
const BaseVehicle = () => {
    const {getSelectedNavState } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    return (
        <>
            <PageHeader/>
            <DataBox/>
        </>
    )
}
export default BaseVehicle